import { h, Fragment } from "preact";
import { useRef, useState } from "preact/hooks";

import IconReaction from "../Icons/IconReaction";
import OnlyIconButton, { OnlyIconButtonVariant } from "../OnlyIconButton";

import ReactionsPopover from "./ReactionsPopover";

interface Props {
    allowMultiSelection?: boolean;
    onOpen?(): void;
    onClose?(): void;
    onSelectReaction(emoji: string): void;
}

export default function AddReactionButton({
    allowMultiSelection = false,
    onOpen,
    onClose,
    onSelectReaction
}: Props) {
    const addReactionButtonRef = useRef<HTMLButtonElement>(null);
    const [isReactionsPopoverVisible, setIsReactionsPopoverVisible] = useState(false);

    function handleButtonClick() {
        onOpen?.();
        setIsReactionsPopoverVisible(true);
    }

    function handleSelectReaction(emoji: string, keepOpen: boolean) {
        setIsReactionsPopoverVisible(allowMultiSelection && keepOpen);
        onSelectReaction(emoji);

        if (!allowMultiSelection || !keepOpen) {
            onClose?.();
        }
    }

    function handleReactionsPopoverClose() {
        setIsReactionsPopoverVisible(false);
        onClose?.();
    }

    return (
        <>
            <OnlyIconButton
                buttonRef={addReactionButtonRef}
                variant={OnlyIconButtonVariant.Ninja}
                icon={IconReaction}
                active={isReactionsPopoverVisible}
                onClick={handleButtonClick}/>
            {isReactionsPopoverVisible && (
                <ReactionsPopover
                    targetButton={addReactionButtonRef}
                    onSelect={handleSelectReaction}
                    onClose={handleReactionsPopoverClose}/>
            )}
        </>
    );
}
